import React, { useContext, useEffect } from 'react';
import {
  AxiomLogo,
  CondensedLarge,
  CondensedMedium,
  Grid,
  GridColumn,
  GridRow,
  Gutter,
  PageContext,
  SmallHeader,
  Well,
} from '@axiom/ui';
import { Link, useLocation, useParams } from 'react-router';

import imageUrl from '../../public/svg/profile-skeleton.svg?url';
import { DefaultLayout } from '../../layouts/DefaultLayout/DefaultLayout';

export type CheckYourEmailProps = {
  name?: string;
};

export const CheckYourEmail = ({
  name = 'CHECK_YOUR_EMAIL',
}: CheckYourEmailProps) => {
  const { setTitle } = useContext(PageContext);
  const location = useLocation();
  const { providedEmail } = useParams();

  useEffect(() => {
    setTitle('Axiom Law - Login');
  }, [setTitle]);

  return (
    <DefaultLayout sideImageUrl={imageUrl} name={name}>
      <Grid centered>
        <GridRow>
          <GridColumn largeScreenWidth={9} tabletWidth={9} mobileWidth={12}>
            <Gutter bottom="24px" className="text-align-center">
              <AxiomLogo width="230px" />
            </Gutter>
            <Gutter bottom="24px">
              <SmallHeader name="HEADER">Check your email</SmallHeader>
            </Gutter>
            <Gutter bottom="24px">
              <CondensedLarge name="SUBTEXT">
                {location.pathname.includes('check-email')
                  ? "We found your account but it looks like you need to complete an additional step before you can sign in. We've sent instructions to your email."
                  : "We've sent sign-in instructions to your email."}
              </CondensedLarge>
            </Gutter>
          </GridColumn>
        </GridRow>
        <GridRow>
          <GridColumn largeScreenWidth={9} tabletWidth={9} mobileWidth={12}>
            {providedEmail ? (
              <Gutter bottom="8px">
                <Well name="EMAIL">
                  <CondensedLarge>{providedEmail}</CondensedLarge>
                </Well>
              </Gutter>
            ) : null}

            <Gutter bottom="24px">
              <CondensedMedium>
                <Link to="/" data-test="BACK">
                  Not you? Sign in with a different account.
                </Link>
              </CondensedMedium>
            </Gutter>
            <CondensedMedium name="CHECK_EMAIL_BODY_COPY">
              If you don't receive that email within an hour, please check your
              spam folder before reaching out to Axiom Answers for{' '}
              <a
                href="mailto:client.answers@axiomlaw.com"
                data-test="CLIENT_EMAIL_LINK"
              >
                Clients
              </a>{' '}
              or{' '}
              <a
                href="mailto:answers@axiomlaw.com"
                data-test="TALENT_EMAIL_LINK"
              >
                Talent
              </a>{' '}
              for assistance.
            </CondensedMedium>
          </GridColumn>
        </GridRow>
      </Grid>
    </DefaultLayout>
  );
};
